export const gridClassName =
  'grid grid-cols-[300px_200px_450px_150px_100px] gap-x-2 lg:grid-cols-[250px_150px_250px_120px_50px] md:grid-cols-[250px_120px_200px_100px_50px] sm:grid-cols-[200px_100px_minmax(150px,_1fr)_120px_minmax(170px,_1fr)]';
